<template>
  <div class="write_address_wrap">
    <div>
      <el-row class="write_tit">
        <el-col :span="4">{{ id ? "修改地址" : "新建地址" }}</el-col>
        <el-col :span="20">
          <i
            class="el-icon-close"
            @click="
              $emit('close');
              clearData();
            "
          ></i>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"> <span class="red_word">*</span> 收货人姓名 </el-col>
        <el-col :span="10">
          <el-input v-model="name"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"> <span class="red_word">*</span> 手机 </el-col>
        <el-col :span="10">
          <el-input v-model="phone" :maxlength="11"></el-input>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="20">
          <el-col :span="2">  电话</el-col>
          <el-col :span="20"> <el-input v-model="tel"></el-input></el-col>
        </el-row>-->
      <el-row :gutter="20">
        <el-col :span="6"> <span class="red_word">*</span> 所在地区 </el-col>
        <el-col :span="17">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-select v-model="zone" placeholder="省" @change="getCityList">
                <el-option
                  v-for="item in zoneList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="city" placeholder="市" @change="getAreaList">
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="area" placeholder="区" @change="getTownList">
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select
                v-model="town"
                v-show="showTownSelect"
                @change="selectTown = false"
              >
                <el-option
                  v-for="item in townList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6"> <span class="red_word">*</span> 详细地址 </el-col>
        <el-col :span="10">
          <el-input v-model="address"></el-input>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="6">地址粘贴版 </el-col>
        <el-col :span="13">
          <div class="addressStickingBoard">
            <el-input
              type="textarea"
              resize="none"
              v-model="addressStickingBoardInputVal"
              ref="addressStickingBoardInput"
              placeholder="试试粘贴收件人姓名、手机号、收货地址，可快速识别您的收货信息"
            >
            </el-input>
            <div class="addressStickingBoardBtns">
              <el-button
                size="mini"
                round
                @click="clearAddressStickingBoardInputVal"
                >清除</el-button
              >
              <el-button
                size="mini"
                round
                @click="submitAddressStickingBoardInputVal"
                >提交</el-button
              >
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="6"> <span class="red_word"></span> 地址标签 </el-col>
        <el-col :span="12">
          <el-radio-group v-model="type">
            <el-radio :label="1">家</el-radio>
            <el-radio :label="2">公司</el-radio>
            <el-radio :label="3">父母家</el-radio>
            <el-radio :label="4">学校</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="6">
          <span class="red_word">*</span> 是否设为默认地址
        </el-col>
        <el-col :span="10">
          <el-radio-group v-model="defaultAddress">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <div class="write_btn">
        <el-col :span="12">
          <el-button @click="saveAddress()">保存</el-button>
        </el-col>
        <el-col :span="12">
          <el-button
            @click="
              $emit('close');
              clearData();
            "
            >取消</el-button
          >
        </el-col>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: Number | null
  },
  data() {
    return {
      name: "",
      phone: "",
      tel: "",
      type: 0,
      zone: "",
      zoneList: [],
      cityList: [],
      city: "",
      areaList: [],
      area: "",
      townList: [],
      town: "",
      address: "",
      defaultAddress: 0,
      showTownSelect: false,
      addressStickingBoardInputVal: "", //地址粘贴板值
      selectTown: false //
    };
  },
  mounted() {
    this.getZoneList();
    if (this.id) {
      this.getAddressDetail(this.id);
    }
  },
  methods: {
    getAddressDetail(id) {
      this.reviseAddress = true;
      this.$reqGet("api/store/address/" + id).then(async res => {
        if (res.data.data) {
          let data = res.data.data;
          this.name = data.name;
          this.phone = data.phone;
          this.zone = data.zone_id;
          this.address = data.address;
          this.type = data.type;
          this.defaultAddress = data.is_default;
          await this.getCityList(false);
          this.city = data.city_id;
          await this.getAreaList(false);
          this.area = data.area_id;
          await this.getTownList(false);
          this.town = data.town_id && data.town_id;
          this.selectTown = false;
        }
      });
    },
    saveAddress() {
      if (this.checkEmpty()) {
        return;
      }
      if (this.phone.length !== 11) {
        this.open("手机号格式不正确");
        return;
      }
      if (this.selectTown) {
        this.open("请手动选择所在街道");
        return;
      }
      if (this.id) {
        this.$reqPut("api/store/address/" + this.id, this.data).then(res => {
          if (res.data.success) {
            let address = {
              ...res.data.data,
              zone: {
                name: res.data.data.zone_name,
                id: res.data.data.zone_id
              },
              city: {
                name: res.data.data.city_name,
                id: res.data.data.city_id
              },
              area: {
                name: res.data.data.area_name,
                id: res.data.data.area_id
              },
              town: {
                name: res.data.data.town_name,
                id: res.data.data.town_id
              }
            };
            this.$bus.emit("editAddress", address);
            this.$emit("getAddressList");
            this.$emit("close");
            this.open2("地址修改成功");
            this.clearData();
          }
        });
        return;
      } else {
        this.$reqPost("api/store/address", this.data).then(res => {
          if (res.data.success) {
            this.$emit("getAddressList");
            this.$emit("close");
            this.open2("地址添加成功");
            this.clearData();
            this.$bus.emit("updateAddressList");
          }
        });
      }
    },
    clearData() {
      this.name = "";
      this.phone = "";
      this.zone = "";
      this.city = "";
      this.area = "";
      this.town = "";
      this.address = "";
    },
    checkEmpty() {
      let flag = false;
      this.data = {
        name: this.name,
        phone: this.phone,
        zone_id: this.zone,
        city_id: this.city,
        area_id: this.area,
        town_id: this.town ? this.town : 0,
        address: this.address,
        type: this.type,
        is_default: this.defaultAddress
      };
      for (let i in this.data) {
        if (flag) break;
        if (!this.data[i]) {
          flag = true;
          if (i === "name") {
            this.open("用户名不能为空");
          } else if (i === "phone") {
            this.open("手机号不能为空");
          } else if (i === "zone_id" || i === "city_id" || i === "area_id") {
            this.open("请选择地址");
          } else if (i === "address") {
            this.open("请填写具体地址");
          } else {
            flag = false;
          }
        } else {
          flag = false;
        }
      }
      return flag;
    },
    checkPhone() {
      var mobileReg = /^1[0-9]{10}$/;
      return mobileReg.test(this.phone);
    },
    getZoneList() {
      this.$reqGet("api/store/address/zone_list").then(res => {
        this.zoneList = res.data.data;
      });
    },
    async getCityList(flag) {
      await this.$reqGet("api/store/address/city_list/" + this.zone).then(
        res => {
          this.cityList = res.data.data;
          if (flag) {
            this.city = "";
            this.area = "";
            this.town = "";
          }
        }
      );
    },
    async getAreaList(flag) {
      await this.$reqGet("api/store/address/area_list/" + this.city).then(
        res => {
          this.areaList = res.data.data;
          if (flag) {
            this.area = "";
            this.town = "";
          }
        }
      );
    },
    async getTownList(flag) {
      await this.$reqGet("api/store/address/town_list/" + this.area).then(
        res => {
          this.townList = res.data.data;
          if (flag) {
            this.town = "";
          }
          if (this.townList && this.townList.length > 0) {
            this.showTownSelect = true;
            this.selectTown = true;
          } else {
            this.showTownSelect = false;
          }
        }
      );
    },
    open(mes) {
      this.$alert(mes, "", {
        confirmButtonText: "确定"
      });
    },
    open2(mes) {
      this.$message({
        message: mes,
        type: "success"
      });
    },
    //清除地址粘贴板内容
    clearAddressStickingBoardInputVal() {
      this.addressStickingBoardInputVal = "";
      this.$nextTick(() => {
        this.$refs.addressStickingBoardInput.focus();
      });
    },
    //提交地址粘贴板的值
    submitAddressStickingBoardInputVal() {
      if (!this.addressStickingBoardInputVal) {
        this.open("请粘贴您的地址信息");
        return;
      }
      this.$reqPost(
        "api/ecomm/getAddressInfoFromContent",
        {
          address_content: this.addressStickingBoardInputVal
        },
        {
          noStringify: true
        }
      ).then(async res => {
        if (res.data.success) {
          let data = res.data.data;
          if (data.name) {
            this.name = data.name;
          }
          if (data.phone) {
            this.phone = data.phone;
          }
          if (data.address) {
            this.address = data.address;
          }
          // if (data.zone_id) {
          //   this.zone = data.zone_id;
          //   this.city = data.city_id;
          //   this.area = data.area_id;
          //   this.town = data.town_id && data.town_id;
          // }
          if (data.zone_id) {
            this.zone = data.zone_id && data.zone_id;
            await this.getCityList(false);
            this.city = data.city_id && data.city_id;
            await this.getAreaList(false);
            this.area = data.area_id && data.area_id;
            await this.getTownList(false);
            this.town = data.town_id && data.town_id;
          }
          // this.addressStickingBoardInputVal = "";
          // 如果town_id为0 通过area_id判断该城市是否为三级
          if (data.town_id == 0 && data.zone_id) {
            this.$reqGet(
              "api/store/address/town_list/" + data.area_id,
              {},
              {
                hideLoading: true
              }
            ).then(res => {
              if (res.data.data.length != 0) {
                this.selectTown = true;
                this.open("请手动选择所在街道");
              }
            });
          }
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.write_address_wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  height: 100vh;
  background: rgba(1, 1, 1, 0.6);
  > div {
    position: fixed;
    width: 680px;
    height: 588px;
    background: rgba(255, 255, 255, 1);
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .el-row {
      margin-bottom: 12px;
      line-height: 32px;
      .el-col:first-child {
        text-align: right;
      }
    }
    .write_tit {
      height: 52px;
      font-size: 26px;
      padding: 15px;
      box-sizing: border-box;
      .el-col:nth-child(2) {
        text-align: right;
        cursor: pointer;
      }
    }
    .write_btn {
      text-align: center;
      padding: 20px 100px;
      .el-button {
        width: 146px;
        height: 40px;
        background: rgba(226, 51, 63, 1);
        border-radius: 5px;
        color: #fff;
        font-size: 16px;
        border: 1px solid rgba(226, 51, 63, 1);
      }
      > div:last-child .el-button {
        background: rgba(250, 250, 250, 1);
        border: 1px solid rgba(219, 219, 219, 1);
        color: #333;
      }
    }
    .addressStickingBoard {
      width: 353px;
      height: 124px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #dddfe6;
      position: relative;
      .el-textarea {
        &::before {
          content: "示例：杨小小，136xxxxxxxx，广东省深圳市南山区xx路xx号";
          display: block;
          width: 100%;
          height: 24px;
          color: #fa4d19;
          background: #fefce3;
          font-size: 12px;
          line-height: 24px;
          text-indent: 8px;
        }
      }
      /deep/ .el-textarea__inner {
        border: none;
      }
      .addressStickingBoardBtns {
        position: absolute;
        bottom: 8px;
        right: 10px;
        > .el-button {
          border: none;
        }
        > .el-button:nth-child(1) {
          color: #dbdbdb;
        }
        > .el-button:nth-child(2) {
          color: #ffffff;
          background: #e2343f;
        }
      }
    }
    .el-input__inner,
    .el-input__icon {
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/address-edit.vue